import { Tooltip } from '@mui/material'
import React, { useEffect, useState } from 'react'

const IcoButtonStatus = ({ ico, text, textStatus, status, onClick, classNameMain }) => {

    const [classNameTemp, setClassNameTemp] = useState('icoButtonStatus')

    useEffect(() => {
        if (classNameMain) {
            setClassNameTemp(classNameMain)
        }
    }, [classNameMain])

  return (
    <p 
        className={`${classNameTemp}__${status}`}
        onClick={onClick}
    >
        <Tooltip title={
            text + ': ' + textStatus
        }>
            {ico}
        </Tooltip>
    </p>
  )
}

export default IcoButtonStatus